import { Icons } from "@/components/icons";
import { cn } from "@/lib/utils";

type SpinnerSize = "sm" | "md" | "lg" | "xl";
type SpinnerTone = "primary" | "muted" | "inverse";

const SIZE_TO_CLASS: Record<SpinnerSize, string> = {
  sm: "h-4 w-4",
  md: "h-6 w-6",
  lg: "h-8 w-8",
  xl: "h-12 w-12",
};

const TONE_TO_CLASS: Record<SpinnerTone, string> = {
  primary: "text-primary",
  muted: "text-muted-foreground/70",
  inverse: "text-foreground",
};

export function LoadingSpinner({
  size = "lg",
  tone = "primary",
  className,
}: {
  size?: SpinnerSize;
  tone?: SpinnerTone;
  className?: string;
}) {
  return (
    <Icons.spinner
      className={cn("animate-spin", SIZE_TO_CLASS[size], TONE_TO_CLASS[tone], className)}
      aria-hidden="true"
    />
  );
}
